<template>
    <div class="form_box"> 
        <div class="tab" :class="{'no':sendBtn.status == 1}" v-if="conf.is_email_register == 1 && conf.is_phone_register == 1">
            <span :class="{'cur':curRegType == 'phone'}" @click="changeTab('phone')">手机注册</span>
            <span :class="{'cur':curRegType == 'email'}" @click="changeTab('email')">邮箱注册</span>
        </div>
        <el-form ref="form" :model="form" label-width="94px" class="" :rules="rules" v-if="conf.is_email_register == 1 || conf.is_phone_register == 1" >
            <!-- 动态注册项 -->
            <div v-if="signItem.length > 0">
                <div  v-for="(item,index) in signItem" :key="index">
                    <el-form-item 
                        v-if="curRegType != item.item_code" 
                        :label="item.item_name+'：'" 
                        :prop="item.item_code"
                        :rules = "signRules(item)"
                    >
                    <!-- 1文本 -->
                    <template v-if="item.input_type == 'text'">
                        <el-input autocomplete="off"  
                            class="toolboox-width"
                            v-model.trim = "form[item.item_code]"
                            type="text" 
                            :maxlength="item.item_length"
                            :placeholder="item.placeholder?item.placeholder:'请输入'+item.item_name">
                        </el-input>
                    </template>
                    <!-- 2时间 -->
                    <template v-if="item.input_type == 'time'">
                        <el-date-picker
                            class="toolboox-width"
                            v-model = "form[item.item_code]"
                            type="date"
                            :placeholder="item.placeholder?item.placeholder:'请选择日期'"
                            value-format="yyyy-MM-dd"
							:picker-options="pickerOptions"
                            >
                        </el-date-picker>
                    </template>
                    <!-- 3开关 -->
                    <template v-if="item.input_type == 'switch'">
                        <el-switch
                            v-model = "form[item.item_code]"
                            active-value="1"
                            inactive-value="0">
                        </el-switch>
                    </template>
                    <!-- 4下拉选项 -->
                    <template v-if="item.input_type == 'select'">
                        <el-select 
                            class="toolboox-width"
                            v-model.trim="form[item.item_code]"
                            :placeholder="'请选择'+item.item_name"
                        >
                            <el-option
                                v-for="(sel,sel_index) in item.options"
                                :key="sel_index"
                                :label="sel.value"
                                :value="sel.code"
                                >
                            </el-option>
                        </el-select>
                    </template>
                    <!-- 5文本域 -->
                    <template v-if="item.input_type == 'textarea'">
                        <el-input autocomplete="off" 
                            class="toolboox-width"
                            v-model.trim="form[item.item_code]"
                            type="textarea"
                            :maxlength="item.item_length"
                            :rows="4"
                            placeholder="请输入内容"
                        >
                        </el-input>
                    </template>
                    <!-- 6单选 -->
                    <template v-if="item.input_type == 'radio'">
                        <el-radio-group  v-model.trim="form[item.item_code]">
                            <el-radio 
								v-for="(sel,sel_index) in item.options"
								:key="sel_index"
								:label="sel.value"
								:value="sel.code"
								>{{ sel.value }}</el-radio>
                        </el-radio-group>
                    </template>
                    <!-- 7多选 -->
                    <!-- <template v-if="item.input_type == 'checkbox'">
                        <el-checkbox-group 
                            v-model="form[item.item_code]"
                        >
                            <el-checkbox 
                            v-for="(sel,sel_index) in item.options"
                            :key="sel_index"
                            :label="sel.code"
                            >{{ sel.value }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </template> -->
                    </el-form-item>
                </div>
            </div>
            <!-- 动态注册项end -->
            <el-form-item label="密码：" prop="password">
				<div class="hidden-input"><input type="text" class="form-control"></div>
				<div class="hidden-input"><input type="password" class="form-control"></div>
                <el-input  v-model.trim="form.password" type="password" show-password autocomplete="new-password" placeholder="密码格式为由大写字母开头,大小写字母、数字、特殊字符中的至少3种组成8~30位的字符串"></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="password2">
                <el-input  v-model.trim="form.password2" type="password" show-password placeholder="请再次确认密码"></el-input>
            </el-form-item>
			<el-form-item label="手机号：" v-if="curRegType == 'phone'" prop="phone" key="phone" :rules = "phoneRule">
				<el-input autocomplete="off"  v-model.trim="form.phone" :disabled="sendBtn.status == 1" placeholder="请输入手机号"></el-input>
			</el-form-item>
			<el-form-item label="邮箱：" v-if="curRegType == 'email'" prop="email" key="email" :rules = "emailRule">
				<el-input autocomplete="off"  v-model.trim="form.email" :disabled="sendBtn.status == 1" placeholder="请输入邮箱"></el-input>
			</el-form-item>
            <el-form-item label="验证码：" prop="captcha">
                <div class="captcha">
                    <el-input autocomplete="off"  placeholder="请输入接收到的验证码" v-model.trim="form.captcha"></el-input>
                </div>
                <div>
                    <el-button @click="sendCaptcha" :disabled="sendBtn.status == 1" type="warning" class="captchaBtn">
                        {{sendBtn.status == 0?'发送验证码':sendBtn.time+'秒后重新发送'}}
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item v-if="conf.is_register_protocol == 1">
                <el-checkbox v-model="read" label="1" style="color:#606266;">我已经阅读</el-checkbox><span class="link" @click="base.show = true">《注册协议》</span>
            </el-form-item>
            <div class="t_center">
                <el-button type="primary" @click="next">下一步</el-button>
            </div>
        </el-form>
        <div v-else class="box_tip">暂不能注册</div>
        <Dialog :base = "base" :btns = "[]" @sure = "sure" width="600px">
            <div v-html="agreement" style="min-height:300px;"></div>
        </Dialog>
    </div>
</template>
<script>
const phoneReg=/^1[3456789]\d{9}$/;
const emailReg=/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
const speen = 60;//倒计时时间
let timer;
import common from "@/utils/common/index.js"
import Dialog from "@/components/public/Dialog"
import Md5 from 'js-md5'
export default {
    name: '',
    props:['conf'],
    components: {Dialog},
    data() {
        return {
            base:{
                show:false,
                title:"注册协议"
            },
            form:{
                birthday:"",
                gender:""
            },
			pickerOptions: {
				disabledDate: time => {
					return time.getTime() > Date.now() - 8.64e6;
				}
			},
            read:"",//阅读协议
            agreement:"",
            curRegType:"",//当前注册类型
            rules:{
                captcha:[{required:true,message:'验证码不能为空',trigger:'blur'}],
                password:[
                    {required:true,message:'密码不能为空',trigger:'blur'},
                    {required: true,pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[A-Z]{1}[a-zA-Z0-9\W_]{7,29}$/,message: '密码格式为由大写字母开头,大小写字母、数字、特殊字符中的至少3种组成8~30位的字符串',trigger: 'blur'}
                ],
                password2:[{required:true,message:'确认密码不能为空',trigger:'blur'}]
            },
            sendBtn:{
                status:0,
                time:speen
            },
            signItem:[],//动态注册项
        }
    },
    watch:{
        conf(news){
            if(this.conf.is_phone_register == '1'){
                this.curRegType = 'phone';
            }else{
                this.curRegType = 'email';
            }
        },
        form:{
            deep:true,
            handler:function(news){
                //选择身份证类型，并且证件号是身份证，则生日自动填充
                let card_no = news.card_no;
                if(news.card_type == 1 && common.isIdCard(card_no)){
                    this.form.birthday = `${card_no.substr(6,4)}-${card_no.substr(10,2)}-${card_no.substr(12,2)}`;
                    this.form.gender = card_no.substr(16,1)%2 == 1?"1":"2";
                }
            }
        }
    },
    computed:{
		//动态注册项必填规则
        signRules(){
            return function(item){
				if(item.is_required=='1'){
					return {required:true,message:item.item_name+'不能为空',trigger: ['blur', 'change']}
				}else{
					return null
				}
            }
        },
        phoneRule(){
            let flag = 0;
            this.signItem.map(item=>{
                if(item.item_code == 'phone'){
                    flag = item.is_required;
                }
            })
            if(this.curRegType == "phone" || flag == 1){
                return [
                    {required:true,message:'手机号不能为空',trigger:'blur'},
                    {required:true,pattern:phoneReg,message:"手机号格式错误",trigger:"blur"}
                ];
            }else{
                return {pattern:phoneReg,message:"手机号格式错误",trigger:"blur"};
            }
            
        },
        emailRule(){
            let flag = 0;
            this.signItem.map(item=>{
                if(item.item_code == 'email'){
                    flag = item.is_required;
                }
            })
            if(this.curRegType == "email" || flag == 1){
                return [
                    {required:true,message:'邮箱不能为空',trigger:'blur'},
                    {required:true,pattern:emailReg,message:"邮箱格式错误",trigger:"blur"}
                ];
            }else{
                return {pattern:emailReg,message:"邮箱格式错误",trigger:"blur"};
            }
        }
    },
    created(){
        this.$store.dispatch("user/getRegProtocol").then(res => {
			if(res.data.length==0){
				this.agreement=''
			}else{
				this.agreement = res.data;
			}
        });
		this.getDetail('phone');
    },
    methods: {
		getDetail(val){
			this.$store.dispatch("user/getRegisterItem").then(res => {
                var list = [];
                res.data.forEach(item => {
                    if(val != item.item_code){
                        list.push(item);
                    }
                });
                this.signItem = list;//动态注册项
			})
		},
        sure(){
            this.base.show = false;
        },
		//下一步
        next(){
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(this.form.card_type == 1 && !common.isIdCard(this.form.card_no)){
                        this.$tip.error("证件号码不是正确的身份证号，请确认后重新输入！");
                        return false;
                    }
                    if(this.conf.is_register_protocol == 1 && !this.read){
                        this.$tip.error("请阅读并勾选注册协议");
                        return false;
                    }
                    if(this.form.password2 != this.form.password){
                        this.$tip.error("两次密码输入不一致，请确认密码！");
                        return false;
                    }
                    let data = JSON.parse(JSON.stringify(this.form));
                    data.password = Md5(this.form.password);
                    data.captcha_type = this.curRegType;
                    this.$store.dispatch("user/register",data).then(res => {
                        this.$emit("next");
                    });
                }
            });
        },
		//发送验证码
        sendCaptcha(){
            let url = '';
            let data={};
            if(this.curRegType == 'phone'){
                if(!this.form.phone){
					this.$tip.error('手机号不能为空！')
					return false;
				}
                if(!phoneReg.test(this.form.phone)){
                    this.$tip.error("手机号格式错误！")
                    return false;
                }
                url='user/sendCaptcha';
                data.phone = this.form.phone;
            }else{
				if(!this.form.email){
					this.$tip.error('邮箱不能为空！')
					return false;
				}
				if(!emailReg.test(this.form.email)){
                    this.$tip.error("邮箱格式错误！")
                    return false;
                }
                url="user/sendEmailCaptcha";
                data.email = this.form.email;
            }
            this.$store.dispatch(url,data).then( res => {
                this.cpatchaTime();
            })
        },
        //验证码倒计时
        cpatchaTime(){
            this.sendBtn.status = 1;
            clearTimeout(timer);
            this.sendBtn.time --;
            if(this.sendBtn.time > 0){
                timer = setTimeout(()=>{
                    this.cpatchaTime();
                },1000)
            }else{
                this.sendBtn = {
                    status:0,
                    time:speen
                }
            }
        },
		//切换注册方式
        changeTab(type){
			if(this.sendBtn.status == 0){
				if(this.form['captcha']){
					this.form['captcha'] = '';
				}
                this.curRegType = type;
                this.clearOldData(type == 'email'?'phone':'email');
				this.getDetail(type)
            }
        },
        //切换的时候清空原来的手机或者邮箱跟验证码
        clearOldData(type){
            this.signItem.map(item=>{
				if(this.form[item.item_code]){
					this.form[type]=''
					this.form[item.item_code]=''
				}
            });
        }
    },
}
</script>
<style lang='scss' scoped >
.form_box{width:750px;margin:20px auto;}
.captcha{width:75%;float:left;}
.captcha+div{width:25%;float:left;text-align:right;}
.captchaBtn{width: 142px;}
/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #606266;
}
.hidden-input{
  position: relative;
  width: 0;
  height: 0;
  overflow: hidden;
}
.hidden-input .form-control{
  position: absolute;
  left: -1000px;
}
</style>